import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ResourcePolicyDeniedIssue } from 'src/app/account/services/issue'
import { UiService } from 'src/app/services/ui.service'
import { ViewableIssue } from '../../issues-view/issues-view.component'

@Component({
  selector: 'resource-policy-permission-issue',
  templateUrl: './resource-policy-permission-issue.component.html',
  styleUrls: ['./resource-policy-permission-issue.component.scss'],
  // Presentational leaf: every binding comes from @Input, so OnPush is safe and
  // skips re-checking this template on unrelated change detection passes.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ResourcePolicyPermissionIssueComponent implements OnInit {
  @Input() issue: ResourcePolicyDeniedIssue = null
  @Input() viewableIssue: ViewableIssue = null

  constructor(public uiService: UiService) {}

  ngOnInit() {}
}
